<div class="flex flex-col bg-(--color-bg-primary) rounded-xl mt-10">
  @if (sections().length === 0) {
    <div class="p-8 text-center text-(--color-text-secondary)">
      {{ 'questionnaire.noData' | translate }}
    </div>
  } @else {
    <div class="flex justify-end px-5 pt-4">
      <button class="flex items-center gap-2 px-3 py-1.5 text-sm border-none rounded cursor-pointer transition-all duration-150 text-(--color-text-secondary) hover:bg-(--color-bg-secondary)" (click)="toggleAllSections()">
        <mat-icon class="text-base w-5 h-5">{{ allExpanded() ? 'unfold_less' : 'unfold_more' }}</mat-icon>
        <span>{{ allExpanded() ? 'Colapsar todo' : 'Expandir todo' }}</span>
      </button>
    </div>
  }
  @for (section of sections(); track section.title) {
    <div class="border-b border-(--color-border)">
      <button class="flex items-center justify-between w-full px-5 py-4 bg-none border-none cursor-pointer transition-all duration-200 hover:bg-black/[0.02]" (click)="toggleSection(section.title)">
        <div class="flex items-center gap-3">
          <mat-icon class="text-xl w-5 h-5" [class]="getIconClasses(section)" [style.color]="getIconColor(section)">{{ section.icon }}</mat-icon>
          <span class="text-base font-semibold text-(--color-text-primary)">{{ section.title }}</span>
        </div>
        <mat-icon style="color: var(--color-text-secondary)">{{ isExpanded(section.title) ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>

      @if (isExpanded(section.title)) {
        <div class="px-5 pb-4">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
            @for (column of section.fields; track $index) {
              <div class="flex flex-col gap-2">
                @for (field of column; track field.key) {
                  <app-data-row class="py-2.5 rounded px-2 -mx-2 transition-colors duration-150 hover:bg-(--color-bg-secondary)" [label]="field.label" [value]="formatValue(field.value)" />
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
